import { render, staticRenderFns } from "./ImportSie.vue?vue&type=template&id=49f9009e&scoped=true&"
import script from "./ImportSie.vue?vue&type=script&lang=ts&"
export * from "./ImportSie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9009e",
  null
  
)

export default component.exports